import PropTypes from 'prop-types';
import {Component} from 'react';

export default class ColumnGroup extends Component {
	static propTypes = {
	    title: PropTypes.node,
	}
}
